import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "base"
};
import { ref } from 'vue';
export default {
  __name: 'Base',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "text"
      }, [_createTextVNode("Copyright © 2025-2030 xinyuemall.com All rights reserved 荷鱼（北京）科技有限公司 版权所有    "), _createElementVNode("a", {
        target: "_blank",
        href: "https://beian.miit.gov.cn/#/Integrated/index"
      }, "京ICP备2025132976号-2")], -1)]))]);
    };
  }
};